export type FileOperationUnavailableReason =
  | 'im_not_connected'
  | 'session_unknown'
  | 'not_single_session'
  | 'stale_session'
  | 'runtime_not_ready'
  | 'presence_unknown'
  | 'peer_offline'
  | null;

export type FileOperationCapability = Readonly<{
  persistentFileAvailable: boolean;
  realtimeAvailable: boolean;
  reason: FileOperationUnavailableReason;
}>;

export type FileOperationCapabilityContext = Readonly<{
  imConnected: boolean;
  sessionKnown: boolean;
  singleSession: boolean;
  sessionCurrent?: boolean;
  realtimeRuntimeReady: boolean;
  peerPresence: number | null | undefined;
}>;

/** Product capability projection. Only canonical ONLINE (1) enables realtime transfer. */
export function evaluateFileOperationCapability(
  context: FileOperationCapabilityContext,
): FileOperationCapability {
  if (!context.imConnected) {
    return { persistentFileAvailable: false, realtimeAvailable: false, reason: 'im_not_connected' };
  }
  if (!context.sessionKnown) {
    return { persistentFileAvailable: false, realtimeAvailable: false, reason: 'session_unknown' };
  }
  if (!context.singleSession) {
    return { persistentFileAvailable: false, realtimeAvailable: false, reason: 'not_single_session' };
  }
  if (context.sessionCurrent === false) {
    return { persistentFileAvailable: false, realtimeAvailable: false, reason: 'stale_session' };
  }

  const persistentFileAvailable = true;
  if (!context.realtimeRuntimeReady) {
    return { persistentFileAvailable, realtimeAvailable: false, reason: 'runtime_not_ready' };
  }
  if (context.peerPresence == null || context.peerPresence === 0) {
    return { persistentFileAvailable, realtimeAvailable: false, reason: 'presence_unknown' };
  }
  if (context.peerPresence !== 1) {
    return { persistentFileAvailable, realtimeAvailable: false, reason: 'peer_offline' };
  }
  return { persistentFileAvailable, realtimeAvailable: true, reason: null };
}

export function realtimeTransferUnavailableMessage(
  reason: FileOperationUnavailableReason,
): string {
  return reason === 'peer_offline'
    ? '对方当前不在线，实时传输未开始'
    : '实时传输暂时无法开始';
}
